/**
 * Serviço de Atividades Esportivas
 *
 * Gerencia operações CRUD de atividades esportivas usando PostgREST.
 * Tabela: atividades_esportivas (id é TEXT, não UUID)
 * 
 * NOTA: Este serviço substitui o antigo modalidades.service.js
 */

import { postgrestClient } from "../lib/postgrest/client";

/**
 * Serviço de atividades esportivas
 */
export const atividadesEsportivasService = {
  /**
   * Lista atividades esportivas com filtros
   * @param {Object} options
   * @param {Object} options.filters - Filtros (ex: { categoria: "eq.Coletiva" })
   * @param {string} options.order - Ordenação (ex: "nome.asc")
   * @param {number} options.limit - Limite de resultados
   * @param {number} options.offset - Offset para paginação
   * @param {string} options.search - Busca por nome
   * @param {boolean} options.includeCount - Se true, retorna { data, total }
   * @returns {Promise<Array|{data: Array, total: number}>}
   */
  async list(options = {}) {
    const { filters = {}, order = "nome.asc", limit, offset, search, includeCount = false } = options;
    
    // Se houver busca, adiciona filtro de nome
    if (search) {
      filters.nome = `ilike.*${search}*`;
    }
    
    const result = await postgrestClient.get("atividades_esportivas", {
      filters,
      order,
      limit,
      offset,
      includeCount,
    });
    
    // Se includeCount, retorna { data, total }, senão retorna array direto
    if (includeCount && result && typeof result === 'object' && 'data' in result) {
      return result;
    }
    return result;
  },

  /**
   * Busca atividade esportiva por ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  async getById(id) {
    const result = await postgrestClient.get("atividades_esportivas", {
      filters: { id: `eq.${id}` },
    });
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Cria nova atividade esportiva
   * @param {Object} atividadeData
   * @returns {Promise<Object>}
   */
  async create(atividadeData) {
    const result = await postgrestClient.post("atividades_esportivas", atividadeData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Atualiza atividade esportiva
   * @param {string} id
   * @param {Object} atividadeData
   * @returns {Promise<Object>}
   */
  async update(id, atividadeData) {
    const result = await postgrestClient.patch("atividades_esportivas", { id }, atividadeData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Remove atividade esportiva
   * @param {string} id
   * @returns {Promise<null>}
   */
  async delete(id) {
    return postgrestClient.delete("atividades_esportivas", { id });
  },

  /**
   * Busca atividades esportivas por categoria
   * @param {string} categoria
   * @returns {Promise<Array>}
   */
  async getByCategoria(categoria) {
    return this.list({
      filters: { categoria: `eq.${categoria}` },
    });
  },
};

export default atividadesEsportivasService;


















